import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { HeaderPopoverService } from '../../services/header-popover.service';
import { PopoverListSelectorComponent } from '../../../shared/ui/popover-list-selector/popover-list-selector.component';

interface Language {
  id: string;
  name: string;
  code: string;
  imageUrl: string;
}

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {
  @ViewChild(PopoverListSelectorComponent) selectorRef: PopoverListSelectorComponent | undefined;

  languages: Language[] = [
    { id: 'English', name: 'English', code: 'EN', imageUrl: 'assets/images/icons/Eng.png' },
    { id: 'Korean', name: 'Korean', code: 'KR', imageUrl: 'assets/images/icons/koria-flag.jpeg' },
    { id: 'Japanese', name: 'Japanese', code: 'JP', imageUrl: 'assets/images/icons/Japan-Flag.png' }
  ];

  selectedLanguage: Language | null = null;

  private popoverSub: Subscription | undefined;

  constructor(
    private translate: TranslateService,
    private headerPopoverService: HeaderPopoverService
  ) {}

  ngOnInit(): void {
    const savedLang = localStorage.getItem('selectedLanguage') || 'English';
    this.selectedLanguage = this.languages.find(l => l.id === savedLang) || this.languages[0];
    this.translate.use(savedLang);

    this.popoverSub = this.headerPopoverService.activePopover$.subscribe((name: string) => {
      if (name !== 'language' && this.selectorRef) {
        this.selectorRef.closeDropdown();
      }
    });
  }

  onVisibleChange(isOpen: boolean): void {
    if (isOpen) {
      this.headerPopoverService.open('language');
    }
  }

  onLanguageSelected(language: Language): void {
    localStorage.setItem('selectedLanguage', language.id);
    this.translate.use(language.id);
    this.selectedLanguage = language;
    window.location.reload();
  }

  ngOnDestroy(): void {
    if (this.popoverSub) {
      this.popoverSub.unsubscribe();
    }
  }
}
